var map = {
	"../exam-period-participate-action/exam-period-participate-action.module": [
		"./src/app/exam-period-participate-action/exam-period-participate-action.module.ts",
		"exam-period-participate-action-exam-period-participate-action-module"
	],
	"../removal-request-action/removal-request-action.module": [
		"./src/app/removal-request-action/removal-request-action.module.ts",
		"default~removal-request-action-removal-request-action-module~student-update-action-student-update-ac~c8caae20",
		"removal-request-action-removal-request-action-module"
	],
	"../student-update-action/student-update-action.module": [
		"./src/app/student-update-action/student-update-action.module.ts",
		"default~removal-request-action-removal-request-action-module~student-update-action-student-update-ac~c8caae20",
		"student-update-action-student-update-action-module"
	],
	"../suspend-request-action/suspend-request-action.module": [
		"./src/app/suspend-request-action/suspend-request-action.module.ts",
		"default~removal-request-action-removal-request-action-module~student-update-action-student-update-ac~c8caae20",
		"suspend-request-action-suspend-request-action-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"default~dashboard-dashboard-module~grades-grades-module~messages-messages-module~registrations-regis~530028c1",
		"default~dashboard-dashboard-module~grades-grades-module",
		"dashboard-dashboard-module"
	],
	"./grades/grades.module": [
		"./src/app/grades/grades.module.ts",
		"default~dashboard-dashboard-module~grades-grades-module~messages-messages-module~registrations-regis~530028c1",
		"default~dashboard-dashboard-module~grades-grades-module"
	],
	"./info-pages/info-pages.module": [
		"./src/app/info-pages/info-pages.module.ts",
		"default~info-pages-info-pages-module~profile-profile-module",
		"info-pages-info-pages-module"
	],
	"./messages/messages.module": [
		"./src/app/messages/messages.module.ts",
		"default~dashboard-dashboard-module~grades-grades-module~messages-messages-module~registrations-regis~530028c1",
		"default~messages-messages-module~requests-requests-module",
		"messages-messages-module"
	],
	"./profile/profile.module": [
		"./src/app/profile/profile.module.ts",
		"default~info-pages-info-pages-module~profile-profile-module",
		"profile-profile-module"
	],
	"./registrations/registrations.module": [
		"./src/app/registrations/registrations.module.ts",
		"default~dashboard-dashboard-module~grades-grades-module~messages-messages-module~registrations-regis~530028c1",
		"registrations-registrations-module"
	],
	"./requests/requests.module": [
		"./src/app/requests/requests.module.ts",
		"default~dashboard-dashboard-module~grades-grades-module~messages-messages-module~registrations-regis~530028c1",
		"default~messages-messages-module~requests-requests-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;